import { classes } from "lib/actions/util";
import { FieldProps } from "formik";
import { InputProps } from "react-html-props";

/** @deprecated Use Input */
export default function FormInput({
  className,
  ...rest
}: InputProps & FieldProps) {
  return (
    <input
      className={classes(
        "w-full p-2 text-lg text-gray-800 placeholder-gray-400",
        "border-none focus:ring-0",
        rest.disabled ? "rounded-lg bg-black bg-opacity-5" : "bg-transparent",
        className,
      )}
      {...rest}
    />
  );
}
